var r=function(r){return{getUserProfile:function(e){return r.getUserProfile({userIDList:e})}}};export{r as useProfile};
